import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { PagoDesgloseComponent } from "./desglose/index";
import { convertirPagoDesglose, convertirPago } from "app/logic/operativa/pago";
import { observeResource } from "kea-resource";
import * as rx from "rxjs";
import { ACredito } from "./creditocomp";
import { componentToRx } from "app/main/std";

type Entity = models.PagoRealizadoModel;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;

    /**Id del cliente que va a pagar */
    idCliente?: number | null;
    /**Importe total a pagar */
    importeAPagar?: number | null;

    /**True para ver el componente de pago  de contado */
    verPagoContado: boolean;
    /**True para ver el componente pago de crédito */
    verPagoCredito: boolean;

    /**Se llama cuando el usuario le da aceptar pago */
    onAceptar: () => void | PromiseLike<void>;
    error?: string;
}

interface PropsPago {
    value: boolean;
    verCredito: boolean;
    verContado: boolean;
    onChange: (x: boolean) => void
}

/**Selector del tipo de pago */
class PagarACredito extends React.PureComponent<PropsPago> {

    verCredito = (x: PropsPago) => x.verCredito;
    verContado = (x: PropsPago) => x.verContado;

    render() {
        const verContado = this.verContado(this.props);
        const verCredito = this.verCredito(this.props);
        const ambosPermisos = verContado && verCredito;

        const soloCredito = [{
            value: true,
            label: "Crédito"
        }];

        const soloContado = [{
            value: false,
            label: "Contado"
        }];

        const ambos = [
            {
                value: false,
                label: "Contado"
            },
            {
                value: true,
                label: "Crédito"
            }
        ];

        const items = ambosPermisos ? ambos : verContado ? soloContado : verCredito ? soloCredito : [];

        return <kea.ButtonSelector {... this.props} items={items} />
    }
}

/**Botón de aceptar */
export class Aceptar extends React.PureComponent<{ onClick: () => void, disabled: boolean, tipo: "credito" | "contado" | "cero" }> {
    render() {
        const tipo = this.props.tipo;
        return (
            <kea.Button style="success" iconClass={fa(
                tipo == "contado" ? "money" :
                    tipo == "credito" ? "credit-card-alt" :
                        tipo == "cero" ? "check" : assertUnreachable(tipo)
            )} {...this.props} >
                {
                    tipo == "contado" ? "Pagar de contado" :
                        tipo == "credito" ? "Pagar a crédito" :
                            tipo == "cero" ? "Aceptar" :
                                assertUnreachable(tipo)
                }
            </kea.Button>
        );
    }
}

/**Captura de un pago con un importe de 0.00 */
class NoRequierePago extends React.PureComponent<Pick<Props, "onAceptar"> & { invalido: boolean }> {
    render() {
        return (
            <div>
                <div className="alert alert-success">
                    <i className={fa("check", "fw")} />
                    <label>Total a pagar: $0.00</label>
                    <br />
                    No se requiere de un pago
        </div>

                <div className="row">
                    <div className="col-md-12">
                        <Aceptar onClick={this.props.onAceptar} disabled={this.props.invalido} tipo="cero" />
                    </div>
                </div>
            </div>
        );
    }
}
const NoRequierePagoRx = componentToRx(NoRequierePago);

/**Captura del pago de credito o de contado */
class CapturaPago extends React.PureComponent<Pick<Props,
    "onAceptar" | "importeAPagar" | "onChange" | "value" | "verPagoContado" | "verPagoCredito"> &
{ invalido: boolean, sugerirCredito: boolean, cliente: models.ClienteCreditoDto | null }> {
    getField = formfields(() => this.props);

    idCliente = (props: Props) => props.idCliente;
    onAceptar = async () => {
        const cli = this.props.cliente;
        if (this.props.sugerirCredito && !this.props.value.EsCredito && cli) {
            if (!await kea.yesno("¿Pagar de contado?", `El cliente ${cli.Nombre} cuenta con un crédito restante de ${kea.formatCurrency(cli.CreditoRestante)}`, "warning")) {
                return;
            }
        }

        await this.props.onAceptar();
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const ModoPago = getField(PagarACredito);

        return (
            <div>
                <ModoPago field="EsCredito" verContado={this.props.verPagoContado} verCredito={this.props.verPagoCredito} />
                <div className="row">
                    <div className="col-md-4"  >
                        <h3>
                            <span className="label label-primary">
                                Total: <label>{kea.formatCurrency(this.props.importeAPagar)}</label>
                            </span>
                        </h3>
                    </div>
                    <div className="col-md-8"  >
                        <div className="btn-group pull-right">
                            <kea.LimpiarButton onClick={() => this.props.onChange(models.pagoRealizadoInicial)} />
                        </div>
                    </div>
                </div>

                {
                    (this.props.verPagoContado || this.props.verPagoCredito) ?
                        (
                            <div>
                                {
                                    value.EsCredito ?
                                        (
                                            (this.props.importeAPagar != null && this.props.cliente && this.props.verPagoCredito) &&
                                            <ACredito cliente={this.props.cliente} totalAPagar={this.props.importeAPagar} />
                                        ) :
                                        (
                                            (this.props.verPagoContado) &&
                                            <PagoDesgloseComponent
                                                value={value} onChange={this.props.onChange} importeAPagar={this.props.importeAPagar || 0}
                                                sugerirCredito={this.props.sugerirCredito}
                                                cliente={this.props.cliente}
                                            />
                                        )
                                }

                                <div className="row">
                                    <div className="col-md-12">
                                        <Aceptar onClick={this.onAceptar} disabled={this.props.invalido} tipo={value.EsCredito ? "credito" : "contado"} />
                                    </div>
                                </div>
                            </div>
                        ) :
                        <div className="alert alert-danger">
                            El usuario no tiene autorizado pagar de ningún modo
                        </div>
                }
            </div>
        );
    }
}
const CapturaPagoRx = componentToRx(CapturaPago);

/**Mensaje de datos incompletos */
class DatosIncompletos extends React.PureComponent {
    render() {
        return (
            <div className="alert alert-danger">
                <span>
                    <i className={fa("exclamation-circle", "fw")} />
                    <label>Datos incompletos</label>
                </span>
                <br />
                Termine de capturar todos los datos para continuar con el pago
             </div>
        );
    }
}

/**
* Componente para editar un Entity
*/
class PagoRealizadoNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    esACredito = (props: Props) => props.value.EsCredito;

    idCliente = (props: Props) => props.idCliente;
    importeAPagar = (props: Props) => props.importeAPagar;
    pagoConvertido = createSelectorRx(this.value, this.importeAPagar, (val, aPagar) => nullsafe(aPagar, aPagar => convertirPago(val, aPagar)));
    invalido = createSelectorRx(this.pagoConvertido, x => x == null || x.error != null);

    cliente = createSelectorRx(this.idCliente, id => {
        console.log("selector cliente pago realizado");
        return id ? observeResource(resources.Cliente.ConsultarDatosCredito, id) : rx.Observable.from([null]);
    });
    limiteCredito = createSelectorRx(this.cliente, cliente => cliente && cliente.LimiteCredito);
    creditoBloqueado = createSelectorRx(this.cliente, cliente => cliente && cliente.CreditoBloqueado);
    saldo = createSelectorRx(this.cliente, cliente => cliente && cliente.SaldoCredito);
    nombreCliente = createSelectorRx(this.cliente, cliente => cliente && cliente.Nombre);

    saldoPago = createSelectorRx(this.saldo, this.importeAPagar, (saldo, importeAPagar) => (saldo || 0) + (importeAPagar || 0));
    superaLimite = createSelectorRx(this.saldoPago, this.limiteCredito, (saldoPago, limiteCredito) => saldoPago > (limiteCredito || 0));
    invalidoCredito = createSelectorRx(this.superaLimite, this.creditoBloqueado, this.esACredito, (superaLimite, creditoBloqueado, esACredito) => esACredito ? (creditoBloqueado ? true : superaLimite) : false);
    esInvalido = createSelectorRx(this.invalido, this.invalidoCredito, (invalidoCredito, invalido) => invalidoCredito || invalido);

    creditoRestante = createSelectorRx(this.saldo, this.limiteCredito, (saldo, limite) => (limite || 0) - (saldo || 0));
    verPagoCredito = (props: Props) => props.verPagoCredito;
    sugerirCredito = createSelectorRx(this.superaLimite, this.verPagoCredito, (supLim, verPagCred) => !supLim && verPagCred);

    render() {
        const { value } = this.props;
        const esInvalido = this.esInvalido(this.props);

        const noNecesitaPago = this.props.importeAPagar == 0 && value.EsCredito == false && value.Conceptos.length == 0 && value.ImporteEfectivoAntesFeria == 0;
        const tieneError = this.props.error != null;
        const sugerirCredito = this.sugerirCredito(this.props);
        const creditoRestante = this.creditoRestante(this.props);
        return (
            tieneError ? <kea.FieldErrorView error={this.props.error} /> :
                noNecesitaPago ? <NoRequierePagoRx {... this.props} invalido={esInvalido} /> :
                    this.props.importeAPagar != null ? <CapturaPagoRx
                        {...this.props}
                        invalido={esInvalido}
                        sugerirCredito={sugerirCredito}
                        cliente={this.cliente(this.props)}
                    />
                        : <DatosIncompletos />
        );
    }
}

export const PagoRealizado = componentToRx(PagoRealizadoNoRx)



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/pago/views/view.tsx